import { render, staticRenderFns } from "./OtherProduct.vue?vue&type=template&id=057366d7&scoped=true&"
import script from "./OtherProduct.vue?vue&type=script&lang=js&"
export * from "./OtherProduct.vue?vue&type=script&lang=js&"
import style0 from "./OtherProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OtherProduct.vue?vue&type=style&index=1&id=057366d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057366d7",
  null
  
)

export default component.exports